import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { EventType } from '../enums/event-type';
import { IAccountPageApplication } from '../account-page-application.interface';

export class AccountPageReadyEvent implements IEvent {
	public static EventType: string = EventType.ACCOUNT_PAGE_READY;

	public readonly timestamp: Date;
	public readonly eventType = AccountPageReadyEvent.EventType;
	public accountPageApplication: IAccountPageApplication;

	constructor(public _accountPageApplication: IAccountPageApplication) {
		this.timestamp = new Date();
		this.accountPageApplication = _accountPageApplication;
	}
}
